import React, { useState, useRef, useEffect, useMemo } from "react";
import styled from 'styled-components'
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import { navData } from "./navData";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import styles from "./sidenav.module.css";
import OTIS_Logo from '../../OTIS_BIG.D.svg';
import { getMsalLogout } from "../../authConfig";
import { getUserRole } from "../common/helpers";
import { ReactComponent as Help } from "../../icons-svg/icons/Help.svg"
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import { getAccessibleNavItems } from "./routeAccess";

export const getUserDetails = () => {
  const { idTokenClaims = {}, username } = JSON.parse(localStorage.getItem('user_profile')) || {};
  const { name = 'NA' } = idTokenClaims;
  const reg = /(\w+)(.|,|,\s)(\w+)/;
  const splitName = name.match(reg) || [];
  const firstName = splitName[3];
  const lastName = splitName[1];
  const userInitials = (typeof (firstName) === "string" && firstName.length > 0 ? firstName.charAt(0) : "N") + (typeof (lastName) === "string" && lastName.length > 0 ? lastName.charAt(0) : "A");
  const userFullName = firstName + " " + lastName;
  return {
    userInitials,
    userFullName,
    username
  }
}
const SideArrows = styled.button`
  align-self: center;
  align-self: flex-start; 
  justify-self: flex-end;
  color: #ffffff;
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin: 0px;
  padding: 0px;
  margin-left: 0px;
  flex-direction: ${props => props.isOpen ? "row" : "column-reverse"};
  z-index: 9;
  svg{
    width: 50px;
    height: 50px;
  }

`
export default function Sidenav(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { role_id } = props;
  const { userInitials, userFullName } = getUserDetails();

  const [open, setOpen] = useState(true)
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [popperItem, setPopperItem] = useState(null);
  const popupCloseTimeout = useRef(null);
  const closePopper = () => {
    setAnchorEl(null);
    setPopperItem(null);
    if (popupCloseTimeout.current) {
      window.clearTimeout(popupCloseTimeout.current);
      popupCloseTimeout.current = null;
    }
  }
  const scheduleClosePopper = () => {
    if (popupCloseTimeout.current) {
      window.clearTimeout(popupCloseTimeout.current);
    }
    popupCloseTimeout.current = window.setTimeout(() => {
      closePopper();
    }, 150);
  }
  const cancelClosePopper = () => {
    if (popupCloseTimeout.current) {
      window.clearTimeout(popupCloseTimeout.current);
      popupCloseTimeout.current = null;
    }
  }
  const toggleOpen = () => {
    setOpen(!open)
  }

  const isLocationUnderChildRoute = () => {
    return navData.some((item) => {
      if (!Array.isArray(item.children)) return false;
      return item.children.some((child) => location.pathname === `/${child.link}`);
    });
  };

  useEffect(() => {
    if (open && isLocationUnderChildRoute()) {
      setSubMenuOpen(true);
    }
  }, [location.pathname, open]);

  const accessibleNavItems = useMemo(() => {
    if (
      role_id === undefined ||
      role_id === null ||
      role_id === ""
    ) {
      return [];
    }

    return getAccessibleNavItems(role_id);
  }, [role_id]);

  return (
    <div className={open ? styles.sidenav : styles.sidenavClosed}>
      <div className={styles.links}>
        <Link to="/">
          <div className="text-center p-2">
            <img style={{ 'height': '17px', 'marginBottom': '18px', 'marginTop': '10px' }} src={OTIS_Logo} alt="OTIS HOMEPAGE" />
          </div>
        </Link>
        {accessibleNavItems.map(item => {
          const hasChildren = Array.isArray(item.children) && item.children.length > 0;
          const parentLink = hasChildren ? `/${item.children[0].link}` : item.link ? `/${item.link}` : '/';
          const isParentActive = hasChildren && item.children.some(child => location.pathname === `/${child.link}`);
          return (
            <div key={item.id} className={styles.sideItemGroup}>
              <div className={styles.sideItemRow}>

                <div
                  key={item.id}
                  onMouseEnter={(e) => {
                    if (!open && hasChildren) {
                      cancelClosePopper();
                      setAnchorEl(e.currentTarget);
                      setPopperItem(item);
                    }
                  }}
                  onMouseLeave={() => {
                    if (!open && hasChildren) {
                      scheduleClosePopper();
                    }
                  }}
                >
                  <NavLink
                    className={({ isActive }) =>
                      `${open ? styles.sideitemOpen : styles.sideitemClose} 
   ${(isActive || isParentActive) ? styles.activeItem : ""}`
                    }
                    to={parentLink}
                    onClick={(e) => {
                      if (hasChildren) {
                        e.preventDefault();
                        const nextOpen = !subMenuOpen;
                        setSubMenuOpen(nextOpen);
                        if (nextOpen) {
                          navigate(parentLink);
                        }
                      } else {
                        setSubMenuOpen(false);
                      }
                    }}
                  >
                    {item.icon}
                    <span className={open ? styles.linkText : styles.linkTextClosed}>{item.text}</span>
                  </NavLink>
                </div>
              </div>
              {hasChildren && open && subMenuOpen && (
                <div className={styles.subNav}>
                  {item.children.map(child => (
                    <NavLink
                      key={child.id}
                      className={({ isActive }) =>
                        `${styles.subNavItem} ${isActive ? styles.activeItem : ""}`
                      }
                      to={`/${child.link}`}
                    >
                      {child.icon}
                      <span className={styles.subNavText}>{child.text}</span>
                    </NavLink>
                  ))}
                </div>
              )}

              {!open && hasChildren && popperItem?.id === item.id && (
                <Popper
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  placement="right-start"
                  style={{ zIndex: 1300 }}
                >
                  <Paper
                    elevation={4}
                    sx={{
                      backgroundColor: '#2a2a2a',
                      minWidth: 200,
                      padding: '6px 0',
                    }}
                    onMouseEnter={cancelClosePopper}
                    onMouseLeave={scheduleClosePopper}
                  >
                    {item.children.map(child => (
                      <NavLink
                        key={child.id}
                        to={`/${child.link}`}
                        onClick={() => {
                          closePopper();
                        }}
                        style={({ isActive }) => ({
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '10px 16px',
                          textDecoration: 'none',
                        })}

                        className={({ isActive }) =>
                          `${styles.subNavItem} ${isActive ? styles.activeItem : ""}`
                        }

                      >
                        {child.icon}
                        <span>{child.text}</span>
                      </NavLink>
                    ))}
                  </Paper>
                </Popper>
              )}
            </div>
          )
        })}
      </div>
      <div className={open ? styles.profileContainer : styles.profileContainerClose}>
        <Link to="https://servicenow.otis.com/esc" target="_blank" className={open ? styles.helpIconOpen : styles.helpIconClose} title="Open a Ticket on Servicenow">
          <div>
            <Help />
          </div>
        </Link>
        <div className={open ? styles.profileSection : styles.profileSectionClose}>
          <div className={open ? styles.profileAvatarOpen : styles.profileAvatarClose}>{userInitials}</div>
          {open && <div className={styles.profileDetail}>
            <p className={styles.userName}>{userFullName}</p>
            <div className={styles.logoutSection}>
              <p className={styles.roleName}>{getUserRole(role_id)}</p>
              <button className={styles.logout} onClick={getMsalLogout}>(Logout)</button>
            </div>
          </div>}
          <SideArrows onClick={toggleOpen} className={open ? styles.open : styles.close} isOpen={open}>
            {open ? <KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
          </SideArrows>
        </div>
      </div>
    </div>
  )
}
